// index.jsでimportしてあります。

import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
import { faUser, faSignOutAlt, faTimes, faExternalLinkAlt, faSearch,
  faChevronRight, faExclamationTriangle, faPhoneAlt, faCalendar,
  faMapMarkerAlt, faFax, faCheck, faMapMarker, faBuilding, faEnvelopeOpen, faUniversity, faHome,
  faChevronCircleUp, faIdBadge, faChevronCircleRight, faChevronCircleLeft, faAngleDoubleDown, faAngleRight, faChevronLeft,
  faGraduationCap, faCalendarMinus, faShoppingCart, faChalkboardTeacher, faBriefcase, faUserTag, faYenSign, faGlobeEurope, faCartPlus, faUserPlus, faLanguage, faSearchLocation , faUnlockAlt, faPenNib, faArrowUpFromBracket,faPrint
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faXTwitter, faInstagram, faYoutube, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faCaretSquareRight, faPlayCircle, faClock, faCreditCard, faPauseCircle } from '@fortawesome/free-regular-svg-icons';

/**
 * fontawesome6
 *
 * 必要なアイコンのみインポートして、library.add で追加します。命名規則はクラス名（ケバブケース）をキャメルケースにしたものです。
 * e.g. <i class="fas fa-sign-out-alt"></i>   -->   faSignOutAlt
 * IconList: https://fontawesome.com/icons
 */
export default () => {
  config.searchPseudoElements = false;
  library.add( faUser, faSignOutAlt, faTimes, faExternalLinkAlt, faSearch,
  faChevronRight, faExclamationTriangle, faPhoneAlt, faCalendar,
  faMapMarkerAlt, faFax, faCheck, faMapMarker, faBuilding, faEnvelopeOpen, faUniversity, faHome,
  faChevronCircleUp, faIdBadge, faChevronCircleRight, faChevronCircleLeft, faAngleDoubleDown, faAngleRight, faChevronLeft,
  faGraduationCap, faCalendarMinus, faShoppingCart, faChalkboardTeacher, faBriefcase, faUserTag, faYenSign, faGlobeEurope, faCartPlus, faUserPlus, faLanguage, faSearchLocation, faUnlockAlt, faPenNib, faArrowUpFromBracket,
  faFacebookF, faXTwitter, faInstagram, faYoutube, faLinkedinIn,
  faCaretSquareRight, faPlayCircle, faClock, faCreditCard, faPauseCircle,faPrint
  );
  dom.watch();
};
